import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../Actions/user';
import { ROUTES } from '../constants';

const LogoutUser = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const logout = async () => {
      try {
        await dispatch(logoutUser());
        navigate(ROUTES.home, { replace: true });
      } catch (error) {
        // Handle any logout errors here
        console.error('Logout failed:', error);
      }
    };

    logout();
  }, [dispatch, navigate]);

  return null; // or you can return a message or component if needed
};

export default LogoutUser;
